import { render, staticRenderFns } from "./communityCourseList.vue?vue&type=template&id=4a0fc49e&scoped=true&"
import script from "./communityCourseList.vue?vue&type=script&lang=js&"
export * from "./communityCourseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0fc49e",
  null
  
)

export default component.exports